import http from 'core/http-common'
import {
  IGetGymSalonTimeTableList,
  IGetGymSalonTimeTableReq,
  IGetGymTrainerTimeTableList,
  IGetGymTrainerTimeTableReq,
  IGymGroupFilteredReq,
  IGymSalonFilteredReq,
  IGymTrainerFilteredReq,
  ISaveGroupLessonReservation,
  ISaveGymSalonReservation,
  ISaveGymTrainerReservation,
} from 'types/GymType'

class GymService {
  getGymServiceDetailByLocationId(locationId: number) {
    return http.get(`GymService/GetByLocationId?locationId=${locationId}`)
  }

  getGymSalonLocations() {
    return http.get(`GymService/GetLocationList`)
  }

  getFilteredGymSalonList<T>(data: IGymSalonFilteredReq) {
    return http.post<T[]>(`GymSaloon/GetFilteredList`, data)
  }

  getFilteredGymGroupList<T>(data: IGymGroupFilteredReq) {
    return http.post<T[]>(`GymGroupLessons/GetFilteredList`, data)
  }

  getFilteredGymTrainerList<T>(data: IGymTrainerFilteredReq) {
    return http.post<T[]>(`GymSaloonTrainer/GetFilteredList`, data)
  }

  /* ############### Reservations ############### */
  /* Gym Salon */
  getGymSalonReservationTableList(data: IGetGymSalonTimeTableReq) {
    return http.post(`GymSaloonReservation/GetTimeTableList`, data)
  }

  saveGymSalonReservation(data: ISaveGymSalonReservation) {
    return http.post<IGetGymSalonTimeTableList[]>(`GymSaloonReservation/SaveReservation`, data)
  }

  /* Gym Group Lesson */
  saveGymGroupLessonReservation(data: ISaveGroupLessonReservation) {
    return http.post(`GymGroupLessonsReservation/SaveReservation`, data)
  }

  /* Gym Trainer */
  getGymTrainerReservationTableList(data: IGetGymTrainerTimeTableReq) {
    return http.post(`GymTrainerReservation/GetTimeTableList`, data)
  }

  saveGymTrainerReservation(data: ISaveGymTrainerReservation) {
    return http.post<IGetGymTrainerTimeTableList[]>(`GymTrainerReservation/SaveReservation`, data)
  }

  /* Favorite - Gym Salon */
  addGymSaloonFavorite(salonId: number) {
    return http.get(`FavoriteGymSaloon/Save?gymSaloonId=${salonId}`)
  }
  removeGymSaloonFavorite(salonId: number) {
    return http.get(`FavoriteGymSaloon/Delete?gymSaloonId=${salonId}`)
  }

  /* Favorite - Gym Group Lesson */
  addGymGroupLessonFavorite(lessonId: number) {
    return http.get(`FavoriteGymGroupLesson/Save?gymGroupLessonId=${lessonId}`)
  }
  removeGymGroupLessonFavorite(lessonId: number) {
    return http.get(`FavoriteGymGroupLesson/Delete?gymGroupLessonId=${lessonId}`)
  }

  /* Favorite - Gym Trainer */
  addGymTrainerFavorite(trainerId: number) {
    return http.get(`FavoriteGymSaloonTrainer/Save?gymSaloonTrainerId=${trainerId}`)
  }
  removeGymTrainerFavorite(trainerId: number) {
    return http.get(`FavoriteGymSaloonTrainer/Delete?gymSaloonTrainerId=${trainerId}`)
  }
}

export default new GymService()
